import { initForm } from './form.js'

export function review () {

    // Обрезка + возможность посмотреть полностью текст на сайте в мобильной версии
    let textContent = document.querySelectorAll('.reviews_item-text__js');
    let viewMoreTextButton = document.querySelectorAll('.show-more__js');

    for (var i = 0; i < textContent.length; i++) {
        let text = textContent[i]

        if (textContent[i].innerHTML.length > 106) {
            let baseText = textContent[i].innerHTML;
            let newText = textContent[i].innerHTML.slice(0, 106) + "...";
            textContent[i].innerHTML = newText;

            viewMoreTextButton[i].addEventListener('click', e => {

                if (!e.target.classList.contains('active')) {
                    e.target.classList.add('active');
                    text.innerHTML = baseText;
                    e.target.innerHTML = "Cкрыть";
                } else {
                    e.target.classList.remove('active');
                    text.innerHTML = newText;
                    e.target.innerHTML = "Читать полностью";
                }
            })
        } else {
            viewMoreTextButton[i].style.display = "none";
        }
    }

    // отправка формы
    document.querySelectorAll('.js-reviewForm').forEach($form => initForm($form, {
        onSuccessCallback: function(r) {
            window.openModal('success', {
                'title':       'Ваш отзыв<br> успешно отправлен!',
                'description': 'Отзыв появится после модерации.',
            });
        }
    }));
}